export const BIRTH_METHOD_OPTIONS = [
	{
		value: 'vaginal',
		label: 'base.vaginal',
	},
	{
		value: 'caesareanSection',
		label: 'base.caesareanSection',
	},
	{
		value: 'vex',
		label: 'base.vex',
	},
	{
		value: 'forceps',
		label: 'base.forceps',
	},
];

export const GENDER_RADIO_OPTIONS = [
	{ title: 'base.woman', value: 'woman' },
	{ title: 'base.man', value: 'man' },
];
